import tabsStyles from './tabs.module.scss';
import tabStyles from './tab.module.scss';

export const tabContainerVariants = ({ isVertical, variant }) => [
  tabsStyles.tabs,
  {
    [tabsStyles.verticalTabs]: isVertical,
  },
  // tabs variants
  {
    [tabsStyles.primaryTabs]: variant === 'primary',
    [tabsStyles.secondaryTabs]: variant === 'secondary',
    [tabsStyles.underlineTabs]: variant === 'underline',
  },
];


export const tabVariants = ({ variant, uppercase, isActive }) => [
  tabStyles.tab,
  // text appearance
  {
    [tabStyles.textUppercase]: uppercase,
  },
  // tab variants
  {
    [tabStyles.primaryTab]: variant === 'primary',
    [tabStyles.activePrimaryTab]: variant === 'primary' && isActive === true,
    [tabStyles.secondaryTab]: variant === 'secondary',
    [tabStyles.activeSecondaryTab]: variant === 'secondary' && isActive === true,
    [tabStyles.underlineTab]: variant === 'underline',
    [tabStyles.activeUnderlineTab]: variant === 'underline' && isActive === true,
  },
];
